import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/axios';
import './plugins/vMask';

Vue.config.productionTip = false

import '@/assets/css/main.scss';

import * as Security from './plugins/security-keycloak';

Vue.prototype.$keycloak = Security.keycloak.instance
Security.keycloak.init()
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')

      store.dispatch('auth/setToken', Security.keycloak.instance.token);
    });

